import React from 'react'

export type StatusIconTone = 'negative' | 'warning' | 'info' | 'grey'

interface StatusIconProps {
  tone: StatusIconTone
  children: React.ReactNode
}

export default function StatusIcon({ tone, children }: StatusIconProps) {
  return (
    <span className={`ss-authentication-shell-status-icon tone-${tone}`} aria-hidden="true">
      {children}
    </span>
  )
}



// WEBPACK FOOTER //
// ./src/shared/components/AuthenticationShell/StatusIcon.tsx